import { render } from "./GroupMemberDialog.vue?vue&type=template&id=68c89560&scoped=true"
import script from "./GroupMemberDialog.vue?vue&type=script&lang=js"
export * from "./GroupMemberDialog.vue?vue&type=script&lang=js"

import "./GroupMemberDialog.vue?vue&type=style&index=0&id=68c89560&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c89560"]])

export default __exports__